import { useWorkspacePanel } from '../../../panels/hooks/use-workspace-panel';
import { RelatedDataTabExistingEvent } from './related-data-tab-existing-event';
import { RelatedDataTabNewEvent } from './related-data-tab-new-event';

export function RelatedDataTab(): React.ReactElement {
    const eventId = useWorkspacePanel().linkedEntityId;
    return eventId ? <RelatedDataTabExistingEvent eventId={eventId} /> : <RelatedDataTabNewEvent />;
}
